var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHightfive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8816 13.6086C19.0636 13.6086 20.0218 12.6504 20.0218 11.4684C20.0218 10.2863 19.0636 9.32812 17.8816 9.32812C16.6996 9.32812 15.7413 10.2863 15.7413 11.4684C15.7413 12.6504 16.6996 13.6086 17.8816 13.6086Z",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96515 4.95996L7.26916 6.72129",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.47559L1.89634 6.88848",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18988 7.64648L4.08622 8.06199",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2099 1L8.52088 1.93815",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0069 3.46484L9.32049 4.403",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0348 4.95898L18.7308 6.72031",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.47559L24.1036 6.88848",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8127 7.64648L21.9138 8.06199",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7927 1L17.4791 1.93815",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.993 3.46289L16.6794 4.40105",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6446 17.8746C21.6498 17.8537 21.655 17.8328 21.6577 17.8119C22.0862 15.9983 23.1211 14.3912 23.7744 12.6481C23.8763 12.3737 23.6751 12.0811 23.3824 12.0811H22.1228C21.7726 12.0811 21.4695 12.3215 21.3806 12.6612C21.1298 13.6203 20.4739 14.4748 19.5984 14.9478C18.5505 15.5122 17.2178 15.5122 16.1698 14.9478C15.3231 14.4879 14.6829 13.6699 14.4164 12.7474C14.3014 12.3476 13.9198 12.0811 13.5043 12.0811H12.3806C12.0958 12.0811 11.892 12.3633 11.9834 12.6324C12.5583 14.3232 13.682 15.8232 14.1028 17.5663C14.3798 18.7082 14.338 19.892 14.3275 21.0602C14.3197 22.0035 14.1968 23.1847 15.263 23.6055C15.6968 23.7753 16.1751 23.7779 16.6376 23.7753C17.5261 23.7727 18.4172 23.7701 19.3057 23.7649C19.8885 23.7649 20.5313 23.7361 20.9521 23.3337C21.4225 22.8816 21.4251 22.1447 21.4068 21.494C21.3702 20.2814 21.3754 19.0558 21.6472 17.872L21.6446 17.8746Z",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46605 13.6086C9.64808 13.6086 10.6063 12.6504 10.6063 11.4684C10.6063 10.2863 9.64808 9.32812 8.46605 9.32812C7.28403 9.32812 6.32581 10.2863 6.32581 11.4684C6.32581 12.6504 7.28403 13.6086 8.46605 13.6086Z",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 12.6651C11.7116 13.6242 11.0557 14.4787 10.1803 14.9517C9.13235 15.5162 7.7996 15.5162 6.75169 14.9517C5.905 14.4918 5.26475 13.6738 4.9982 12.7513C4.88322 12.3515 4.50169 12.085 4.08618 12.085H2.96248C2.67764 12.085 2.47381 12.3672 2.56527 12.6364C3.14018 14.3271 4.26388 15.8271 4.68461 17.5702C4.96162 18.7122 4.9198 19.8959 4.90935 21.0641C4.90151 22.0075 4.77869 23.1886 5.84489 23.6094C6.27869 23.7792 6.75691 23.7818 7.21946 23.7792C8.10796 23.7766 8.99908 23.774 9.88758 23.7688C10.4703 23.7688 11.1132 23.74 11.5339 23.3376C12.0043 22.8855 12.0069 22.1486 11.9886 21.4979C11.952 20.2853 11.9573 19.0597 12.2291 17.8759C12.2343 17.855 12.2395 17.8341 12.2421 17.8132C12.4329 17.0031 12.7465 16.2322 13.0914 15.4743",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9765 3.37012L13.0235 5.56263",
    stroke: "#5B5FC7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHightfive);
export default __webpack_public_path__ + "static/media/hightfive.442cff1105d01dc43d81ad1a4b9032ab.svg";
export { ForwardRef as ReactComponent };